/* Visual comparison prices for the approved Hot Sale theme.
   Never writes product prices, variant prices, cart payloads or Shopify data. */
(function () {
  'use strict';
  if (window.__miHsReferences) return;
  window.__miHsReferences = true;
  function money(cents) {
    return '$' + Math.round(cents / 100).toLocaleString('es-CO');
  }
  function text(card, selector, value) {
    var node = card.querySelector(selector);
    if (node && node.textContent !== value) node.textContent = value;
  }
  function show(card, selector, visible) {
    var node = card.querySelector(selector);
    if (node && node.hidden === visible) node.hidden = !visible;
  }
  function update(card) {
    var campaign = window.miHotSale;
    var active = !!(campaign && campaign.campaign && campaign.active);
    var selected = card.querySelector('[data-mi-talla][aria-pressed="true"]');
    var data = selected ? selected.dataset : card.dataset;
    var price = Number(data.miHsPriceCents);
    var original = Number(data.miHsCompareCents) || 0;
    if (!Number.isFinite(price) || price < 0) return;
    var reference = original;
    var generated = active && price > 0 && original <= price && data.miHsReferenceEligible === 'true';
    if (generated) {
      var rate = Math.max(10, Math.min(15, Number(card.dataset.miHsReferenceRate) || 12));
      reference = Math.round(price / (100 - rate)) * 100;
    }
    var saving = Math.max(0, reference - price);
    var discount = reference > price ? Math.round(saving * 100 / reference) : 0;
    var discounted = reference > price;
    var discountLabel = discount > 0 ? '-' + discount + '%' : '<1%';
    text(card, '[data-mi-antes-txt]', reference > price ? money(reference) : '');
    text(card, '[data-mi-dto-txt]', discountLabel);
    text(card, '[data-mi-ahorra-txt]', reference > price ? 'Ahorras ' + money(saving) : 'ahorra');
    var referenceBox = card.querySelector('[data-mi-antes-caja]');
    if (referenceBox) {
      if (generated) referenceBox.title = 'Precio de referencia estimado a partir del descuento informado; no es un precio anterior verificado.';
      else referenceBox.removeAttribute('title');
    }
    show(card, '[data-mi-antes-caja]', reference > price);
    show(card, '[data-mi-dto-caja]', discounted);
    show(card, '[data-mi-ahorra-caja]', reference > price);
    card.toggleAttribute('data-mi-hs-generated-reference', generated);
    // Keep campaign filters and ordering consistent with the card's selected size.
    var item = card.closest('[data-mi-hs-live]');
    if (item) {
      item.dataset.miHsPrice = String(price / 100);
      item.dataset.miHsCompare = String(Math.max(reference, price) / 100);
    }
  }
  function refresh(scope) {
    if (scope.matches && scope.matches('[data-mi-tarjeta][data-mi-hs-reference-rate]')) update(scope);
    if (scope.querySelectorAll) scope.querySelectorAll('[data-mi-tarjeta][data-mi-hs-reference-rate]').forEach(update);
  }
  function init() {
    refresh(document);
    new MutationObserver(function (records) {
      records.forEach(function (record) {
        record.addedNodes.forEach(function (node) { if (node.nodeType === 1) refresh(node); });
      });
    }).observe(document.getElementById('root'), { childList: true, subtree: true });
  }
  document.addEventListener('click', function (event) {
    var chip = event.target.closest && event.target.closest('[data-mi-talla]');
    if (!chip || chip.disabled) return;
    var card = chip.closest('[data-mi-tarjeta][data-mi-hs-reference-rate]');
    if (card) window.requestAnimationFrame(function () { update(card); });
  }, true);
  document.addEventListener('mi-hot-sale-change', function () { refresh(document); });
  document.addEventListener('shopify:section:load', function (event) { refresh(event.target); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
